var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M11.3333 5.33073H12.6667C13.403 5.33073 14 5.92768 14 6.66406V10.6641C14 11.4004 13.403 11.9974 12.6667 11.9974H11.3333V14.6641L8.66667 11.9974H6C5.63181 11.9974 5.29848 11.8482 5.05719 11.6069M5.05719 11.6069L7.33333 9.33073H10C10.7364 9.33073 11.3333 8.73378 11.3333 7.9974V3.9974C11.3333 3.26102 10.7364 2.66406 10 2.66406H3.33333C2.59695 2.66406 2 3.26102 2 3.9974V7.9974C2 8.73378 2.59695 9.33073 3.33333 9.33073H4.66667V11.9974L5.05719 11.6069Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIcon);
export default __webpack_public_path__ + "static/media/ChatIcon.701aba6b3555501e9bcde65615121d7e.svg";
export { ForwardRef as ReactComponent };